import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useRecoilState } from "recoil";

import { buildNeedReloadAtom, Log } from "@ryde/shared";

export const RoutingInterceptor = (): null => {
  const location = useLocation();
  const [buildNeedReload, setBuildNeedReload] =
    useRecoilState(buildNeedReloadAtom);
  const prevLocationRef = useRef<string | null>(null);

  useEffect(() => {
    const currentLocation = location.pathname + location.search + location.hash;

    if (
      buildNeedReload &&
      prevLocationRef.current &&
      prevLocationRef.current !== currentLocation
    ) {
      Log.info("Version changed, starting reload...");
      setBuildNeedReload(false);
      window.location.reload();
    }

    prevLocationRef.current = currentLocation;
  }, [location, buildNeedReload, setBuildNeedReload]);

  return null;
};
